// extracted by mini-css-extract-plugin
module.exports = {"dialog":"Dialog_dialog__zES09","header":"Dialog_header__bnz0W"};